export default __webpack_public_path__ + "static/testimonial-bg-desktop-dark-5317065f0bfaea887af9aaac2288d12a.png";